import { Select, 
         Checkbox, 
         Divider                      }     from "antd";   
import React from "react";
import Style from "components/UI/main.module.scss";
import { GetSystemLabel ,GetAppLang } from "Utilities/utils";

//documentation -> https://ant.design/components/select

//For both option the listOfItems should follow the following model
//[ {value: 'value1', label: 'labelForValue1'},
//  {value: 'value2', label: 'labelForValue2'},
//  {value: 'value3', label: 'labelForValue3'} ]

//Dropdown list with searching feature
//Allows users to type in order to filter the list items

export const DropdownListMultiple = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
    returnObject = false,
}) => {

    const selectedValues = Array.isArray(value) ? value : [];

    const allValues = returnObject
        ? (listOfItems ?? [])
        : (listOfItems?.map(item => item?.value) ?? []);

    const allSelected =
        selectedValues.length === allValues.length;

    const handleSelectAll = (checked) => {
        onChange?.(checked ? allValues : []);
    };

    return (
        <Select
            mode="multiple"
            labelInValue={returnObject}
            showSearch
            allowClear
            id={id}
            name={name}
            value={value}
            placeholder={placeholder}
            className={className}
            style={style}
            title={title}
            popupClassName={popupClassName}
            options={listOfItems}
            optionFilterProp="label"
            filterOption={(input, option) =>
                (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            onChange={(val, option) => {
                onChange?.(val, option);
            }}
            onSearch={(val) => {
                onSearch?.(val);
            }}
            notFoundContent={null}
            dropdownRender={(menu) => (
                <>
                    <div style={{ padding: 8 }}>
                        <Checkbox
                            checked={allSelected}
                            indeterminate={
                                selectedValues.length > 0 &&
                                selectedValues.length < allValues.length
                            }
                            onChange={(e) =>
                                handleSelectAll(e.target.checked)
                            }
                            className={Style.text_body}
                        >
                            {GetSystemLabel("Select")}
                        </Checkbox>
                    </div>

                    <Divider style={{ margin: "8px 0" }} />

                    {menu}
                </>
            )}
        />
    );
};
export const SearchableDropdownList    = ({    className,
                                        style,
                                        onChange,
                                        onSearch,
                                        listOfItems,
                                        placeholder,
                                        id,
                                        name,
                                        defaultValue,
                                        title,
                                        popupClassName,
                                        value,} ) => {
    return (
        <Select
            showSearch
            allowClear
            id={id}
            name={name}
            value={value} // use directly from props
            placeholder={placeholder}
            className={className}
            style={style}
            title={title}
            popupClassName={popupClassName}
            options={listOfItems}
            optionFilterProp="label"
            filterOption={(input, option) =>
                String(option?.label ?? '')
                    .toLowerCase()
                    .includes(String(input).toLowerCase())
            }
            onChange={(val, option) => {
                onChange?.(val, option); // lift change to parent
            }}
            onSearch={(val) => {
                onSearch?.(val);
            }}
            notFoundContent={null}
        />
    );
};

//Regular dropdown list
export const DropdownList = ({
  className,
  style,
  onChange,
  listOfItems,
  placeholder,
  id,
  name,
  defaultValue,
  value,
  disabled,
  title,
}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      style={style}
      options={listOfItems}
      className={className}
      onChange={onChange}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      title={title}
    />
  );
};

const DropdownListField = ({
  className,
  style,
  onChange,
  listOfItems,
  placeholder,
  search,
  id,
  name,
  defaultValue,
  value,
  disabled,
  title,
}) => (
  <div>
    {
      //Check if the developer wants to use a dropdownlist with searching feature that allows users to type in order to filter the list
      search == true ? (
        <SearchableDropdownList
          defaultValue={defaultValue}
          className={className}
          name={name}
          id={id}
          style={style}
          onChange={onChange}
          listOfItems={listOfItems}
          placeholder={placeholder}
          title={title}
        />
      ) : (
        <DropdownList
          defaultValue={defaultValue}
          className={className}
          name={name}
          id={id}
          style={style}
          onChange={onChange}
          listOfItems={listOfItems}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          title={title}
        />
      )
    }
  </div>
);

export default DropdownListField;
